var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UploadFileDialog',{ref:"uploadFile",attrs:{"open":_vm.value,"isUploadLoading":_vm.getUploadAllEntriesLoading},on:{"upload":_vm.upload,"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }